export default {
	title: "Monitoring",
	url: "monitoring",
	subtitle: "Strategischer Monitoring-Bericht durch anonymisierte Recherche: Das Projektthema wird neutralisiert, bevor öffentliche Quellen abgefragt werden. Der Bericht deckt den Makro-Kontext (PESTEL), den Branchenkontext (Porters 5 Kräfte) und den internen Kontext ab, mit starken und schwachen Signalen.",
	current: "Aktueller Bericht",
	archive: "Archiv",
	context_tab: "Kontext",
	empty: "Noch kein Monitoring-Bericht für dieses Projekt.",
	generated_on: "Erstellt am",
	actions: {
		generate: "Bericht erstellen",
		generate_new: "Neuen Bericht erstellen",
		generating: "Wird erstellt… (etwa zehn Minuten)",
		retry: "Erneut versuchen",
		print: "Drucken",
		delete: "Diesen Bericht löschen",
		delete_confirm: "Diesen Bericht endgültig löschen?"
	},
	steps: {
		anonymizing: "Anonymisierung des Themas",
		researching: "Recherche und Redaktion",
		done: "Bericht verfügbar",
		elapsed: "seit {{minutes}} Min."
	},
	messages: {
		failed: "Erstellung fehlgeschlagen",
		neutral_subject: "Gesendetes anonymisiertes Thema",
		confirm_title: "Anonymisiertes Monitoring starten?",
		confirm_body: "Das Projektthema wird anonymisiert, bevor öffentliche Quellen durchsucht werden. Die Erstellung des Berichts dauert etwa zehn Minuten."
	}
};
